/** Ticket deep-link recovery — stale service worker / chunk load failures. */

export const TICKET_SW_RECOVERY_KEY = 'lockedin_ticket_sw_recovery';

export function isTicketDeepLinkPath(pathname = '') {
  return String(pathname || '').startsWith('/ticket/');
}

export function isChunkLoadError(message = '') {
  return /ChunkLoadError|Loading chunk/i.test(String(message || ''));
}

export function markTicketAppMounted() {
  if (typeof window !== 'undefined') {
    window.__ticketReactMounted = true;
    const bootStart = window.__ticketBootStart;
    if (typeof bootStart === 'number') {
      console.log(`[ticket] React mounted in ${Date.now() - bootStart}ms`);
    }
  }
  if (typeof window !== 'undefined' && typeof window.__ticketMarkAppMounted === 'function') {
    window.__ticketMarkAppMounted();
    return;
  }
  if (typeof document !== 'undefined') {
    document.getElementById('ticket-pre-react-fallback')?.remove();
    document.getElementById('ticket-slow-load')?.remove();
  }
}

export function logTicketIndexBoot() {
  if (typeof window === 'undefined' || !isTicketDeepLinkPath(window.location.pathname)) return;
  console.log('[ticket] index boot started');
}

export async function recoverTicketServiceWorkerCaches() {
  if (typeof sessionStorage !== 'undefined') {
    if (sessionStorage.getItem(TICKET_SW_RECOVERY_KEY) === '1') return false;
    sessionStorage.setItem(TICKET_SW_RECOVERY_KEY, '1');
  }

  if (typeof navigator !== 'undefined' && navigator.serviceWorker) {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((reg) => reg.unregister()));
  }

  if (typeof caches !== 'undefined') {
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
  }

  return true;
}

export function initTicketDeepLinkRecovery() {
  if (typeof window === 'undefined' || !isTicketDeepLinkPath(window.location.pathname)) return;

  const handleFailure = async (message) => {
    if (!isChunkLoadError(message)) return;
    const recovered = await recoverTicketServiceWorkerCaches();
    if (recovered) window.location.reload();
  };

  window.addEventListener('error', (event) => {
    handleFailure(event?.message);
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason;
    handleFailure(reason?.message || reason);
  });
}

export function shouldSkipServiceWorkerControllerReload() {
  if (typeof sessionStorage === 'undefined') return false;
  if (sessionStorage.getItem(TICKET_SW_RECOVERY_KEY) !== '1') return false;
  sessionStorage.removeItem(TICKET_SW_RECOVERY_KEY);
  return true;
}
